<template>
    <q-checkbox v-model="internalModel" dense :name="name" v-bind="$attrs">
        <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope || {}"></slot>
        </template>
    </q-checkbox>
</template>

<script>
import { ref, watch } from "vue";

export default {
    name: "CheckboxWrapper",
    props: ["modelValue", "name"],
    setup(props) {
        const internalModel = ref(props.modelValue);

        watch(
            () => props.modelValue,
            (val) => {
                internalModel.value = val;
            },
        );

        return { internalModel };
    },
};
</script>
